<template>
  <svg class="icon"
       width="8"
       height="1"
       viewBox="0 0 8 1"
       fill="none"
       xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="8" height="1" fill="#1E2945" />
  </svg>
</template>
